import { Modal } from "antd";
import { CustomModalProps } from "../../types";

export default function CustomModal({
  title = "",
  open,
  centered = true,
  className = "",
  disableCloseButton = false,
  handleClose,
  children,
  ...rest
}: CustomModalProps) {
  return (
    <Modal
      title={title}
      open={open}
      centered={centered}
      className={`custom-modal ${className}`}
      onCancel={() => !disableCloseButton && handleClose && handleClose()}
      {...rest}
    >
      {children}
    </Modal>
  );
}
